export default "__VITE_ASSET__8yu7yrfO__";